// extracted by mini-css-extract-plugin
module.exports = {"glowing_number":"style_glowing_number__St4WE","desktop_glowing_number":"style_desktop_glowing_number__Jk1Up"};